// removed by extract-text-webpack-plugin
module.exports = {"searchHighlight":"_3OSW7nTEkQ5-8AKGBkc1S7_0"};


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!/export/jenkins/workspace/dev-isrs-frontend-mb_dev/~/vue-style-loader!/export/jenkins/workspace/dev-isrs-frontend-mb_dev/~/css-loader?{"sourceMap":true,"autoprefixer":false,"localIdentName":"[hash:base64]_0","modules":true,"importLoaders":true}!/export/jenkins/workspace/dev-isrs-frontend-mb_dev/~/vue-loader/lib/style-compiler?{"id":"data-v-acb28ee6","scoped":false,"hasInlineConfig":false}!/export/jenkins/workspace/dev-isrs-frontend-mb_dev/~/vue-loader/lib/selector.js?type=styles&index=0!./client/views/returnShopPortals/List.vue
// module id = 1024
// module chunks = 1